export function useMoney() {
    function dollars(cents: number) {
        return (cents / 100).toFixed(2);
    }

    function dollarsForDisplay(cents: number) {
        return dollars(cents).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return {
        dollars,
        dollarsForDisplay,
    };
}
